import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ListService, PagedResultDto, ABP } from '@abp/ng.core';
import { EXTENSIONS_IDENTIFIER } from '@abp/ng.theme.shared/extensions';
import { eTerminalManagementComponents } from '../../enums';
import { Store, Select } from '@ngxs/store';
import { IdentityUserExtensionService } from '../../services/identity-users-extension.service';
import { GetUsersByTenantRequest, UserData, AppModuleManagement } from '../../models';
import { BindUsers, GetAppTerminalSettings } from '../../actions/terminal-management.actions'
import { finalize } from 'rxjs/operators';
import { TerminalManagementState } from '../../states/terminal-management.state';
import { Observable } from 'rxjs';

@Component({
	selector: 'terminal-users-modal',
	template: `
    <abp-modal [(visible)]="isModalVisible" [busy]="isModalBusy">
    <ng-template #abpHeader>
        <h3>{{ 'TerminalManagement::LoginUserManagement' | abpLocalization }}</h3>
    </ng-template>

    <ng-template #abpBody>
		<div id="data-tables-table-filter" class="data-tables-filter">
			<div class="input-group">
				<input
				type="search"
				class="form-control"
				[placeholder]="'AbpUi::PagerSearch' | abpLocalization"
				[(ngModel)]="list.filter"
				/>
				<div class="input-group-append">
					<button class="btn btn-sm btn-primary" (click)="list.get()">
						<i class="fas fa-search"></i>
					</button>
				</div>
			</div>
		</div>
		 
		 

		<ngx-datatable [rows]="allUsers.items" [count]="allUsers.totalCount" [list]="list" default>
			
		<ngx-datatable-column [name]="'AbpIdentity::Actions' | abpLocalization" [maxWidth]="120"
						[sortable]="false">
			<ng-template let-row="row" ngx-datatable-cell-template>
				<input
					type="checkbox"
					[(ngModel)]="checkUsers[row.id]"
				/>
			</ng-template>
		</ngx-datatable-column>
		<ngx-datatable-column [width]="100" [name]="'AbpIdentity::UserName' | abpLocalization" prop="userName" [sortable]="false">
		</ngx-datatable-column>
		<ngx-datatable-column [width]="100" [name]="'AbpIdentity::EmailAddress' | abpLocalization" prop="email" [sortable]="false">
		</ngx-datatable-column>
		<ngx-datatable-column [width]="100" [name]="'AbpIdentity::PhoneNumber' | abpLocalization" prop="phoneNumber" [sortable]="false">
		</ngx-datatable-column>
		</ngx-datatable>

    </ng-template>

    <ng-template #abpFooter>
        <button type="button" class="btn btn-secondary" #abpClose>
        {{ 'AbpIdentity::Cancel' | abpLocalization }}
        </button>
        <abp-button iconClass="fa fa-check" (click)="addUsers()">{{
        'AbpIdentity::Save' | abpLocalization
        }}</abp-button>
    </ng-template>
</abp-modal>
	`, providers: [
		ListService,
		{
			provide: EXTENSIONS_IDENTIFIER,
			useValue: eTerminalManagementComponents.TerminalUsers
		}
	]

})
export class TerminalUsersModalComponent implements OnInit, OnChanges {

	@Input() checkUsers: ABP.Dictionary<boolean> = {};
	@Input() tenant: ABP.BasicItem;
	terminalId: string;

	isModalVisible: boolean = false;
	isModalBusy: boolean = false;
	allUsers = { items: [], totalCount: 0 } as PagedResultDto<UserData>;

	@Select(TerminalManagementState.appTerminalSettings)
	appTerminalSettings$: Observable<AppModuleManagement.AppTerminalSettingItem>;

	constructor(
		public readonly list: ListService,
		private store: Store,
		private identityService: IdentityUserExtensionService) {

	}

	ngOnChanges(changes: SimpleChanges): void {
		for (const key in changes) {
			if (Object.prototype.hasOwnProperty.call(changes, key)) {
				const element = changes[key];
				if (key === 'tenant' && element) {
					this.hookToQuery();
				}
			}
		}
	}

	ngOnInit(): void {

		this.appTerminalSettings$.subscribe(appsettings => {
			if (!appsettings) return;

			this.checkUsers = {};
			appsettings.allowUsers.map(x => x.id).forEach(x => {
				this.checkUsers[x] = true;
			});
		});
	}

	addUsers() {
		this.isModalBusy = true;
		let users = [];
		for (const key in this.checkUsers) {
			if (Object.prototype.hasOwnProperty.call(this.checkUsers, key)) {
				users.push(key);
			}
		}

		this.store.dispatch(new BindUsers({
			terminalId: this.terminalId,
			users: users
		})).pipe(finalize(() => {
			this.isModalBusy = false;
			this.isModalVisible = false;
		})).subscribe();
	}

	private hookToQuery() {

		this.list
			.hookToQuery(query => {
				let q = { ...query } as GetUsersByTenantRequest;
				q.tenantId = this.tenant.id;
				return this.identityService.usersByTenant(q);
			})
			.subscribe(response => {
				this.allUsers = response;
			});
	}

	show(terminalId: string) {
		this.isModalVisible = true;
		this.terminalId = terminalId;
		this.getTerminallSetting();
	}

	getTerminallSetting() {
		this.store.dispatch(new GetAppTerminalSettings(this.terminalId)).subscribe();
	}

}